// Note: 這隻檔案跟後端有在 wording 資料夾共用，改動需要跟後端說

type languageType =
  | "tr"
  | "tw"
  | "zh-TW"
  | "zh-CN"
  | "da"
  | "eu"
  | "ja"
  | "mi"
  | "jw"
  | "eo"
  | "gl"
  | "ca"
  | "kn"
  | "ne"
  | "af"
  | "fy"
  | "be"
  | "lt"
  | "ig"
  | "is"
  | "hu"
  | "id"
  | "su"
  | "hi"
  | "gu"
  | "ky"
  | "es"
  | "hr"
  | "iw"
  | "el"
  | "hy"
  | "az"
  | "ny"
  | "bn"
  | "ps"
  | "la"
  | "lv"
  | "fr"
  | "bs"
  | "fa"
  | "pl"
  | "fi"
  | "am"
  | "ar"
  | "sq"
  | "ru"
  | "bg"
  | "sd"
  | "xh"
  | "zu"
  | "kk"
  | "cy"
  | "co"
  | "hmn"
  | "en"
  | "haw"
  | "ku"
  | "no"
  | "pa"
  | "th"
  | "ta"
  | "te"
  | "ht"
  | "uk"
  | "uz"
  | "ur"
  | "so"
  | "mt"
  | "ms"
  | "mk"
  | "mg"
  | "mr"
  | "ml"
  | "km"
  | "ceb"
  | "cs"
  | "sn"
  | "nl"
  | "ka"
  | "sw"
  | "sk"
  | "sl"
  | "tl"
  | "vi"
  | "tg"
  | "sr"
  | "yi"
  | "et"
  | "ga"
  | "sv"
  | "st"
  | "it"
  | "pt"
  | "mn"
  | "ha"
  | "lo"
  | "de"
  | "my"
  | "lb"
  | "si"
  | "yo"
  | "ko"
  | "sm"
  | "ro"
  | "gd";

const languageCodesData = {
  tr: {
    "zh-TW": "土耳其文",
    en: "Turkish",
    ja: "トルコ語",
    th: "ภาษาตุรกี",
    "zh-hans": "土耳其文",
    originalName: "Türkçe",
  },
  tw: {
    "zh-TW": "繁體中文",
    en: "Traditional Chinese",
    ja: "繁体字中国語",
    th: "ภาษาจีนตัวเต็ม",
    "zh-hans": "繁体中文",
    originalName: "繁體中文",
  },
  "zh-hans": {
    "zh-TW": "簡體中文",
    en: "Simplified Chinese",
    ja: "簡体字中国語",
    th: "ภาษาจีนตัวย่อ",
    "zh-hans": "简体中文",
    originalName: "简体中文",
  },
  "zh-TW": {
    "zh-TW": "中文 (繁體)",
    en: "Chinese (Traditional)",
    ja: "繁体字中国語",
    th: "ภาษาจีนดั้งเดิม",
    "zh-hans": "繁体中文",
    originalName: "中文 (繁體)",
  },
  "zh-CN": {
    "zh-TW": "中文 (簡體)",
    en: "Chinese (Simplified)",
    ja: "簡体字中国語",
    th: "ภาษาจีนตัวย่อ",
    "zh-hans": "简体中文",
    originalName: "中文(简体)",
  },
  da: {
    "zh-TW": "丹麥文",
    en: "Danish",
    ja: "デンマーク語",
    th: "ภาษาเดนมาร์ก",
    "zh-hans": "丹麦文",
    originalName: "Dansk",
  },
  eu: {
    "zh-TW": "巴斯克文",
    en: "Basque",
    ja: "バスク語",
    th: "ภาษาบาสก์",
    "zh-hans": "巴斯克文",
    originalName: "euskara",
  },
  ja: {
    "zh-TW": "日文",
    en: "Japanese",
    ja: "日本語",
    th: "ภาษาญี่ปุ่น",
    "zh-hans": "日文",
    originalName: "日本語",
  },
  mi: {
    "zh-TW": "毛利文",
    en: "Maori",
    ja: "マオリ語",
    th: "ภาษาเมารี",
    "zh-hans": "毛利文",
    originalName: "Māori",
  },
  jw: {
    "zh-TW": "爪哇文",
    en: "Javanese",
    ja: "ジャワ語",
    th: "ภาษาชาวา",
    "zh-hans": "爪哇文",
    originalName: "Basa Jawa",
  },
  eo: {
    "zh-TW": "世界語",
    en: "Esperanto",
    ja: "エスペラント語",
    th: "ภาษาเอสเปรันโต",
    "zh-hans": "世界语",
    originalName: "世界語",
  },
  gl: {
    "zh-TW": "加里西亞文",
    en: "Galician",
    ja: "ガリシア語",
    th: "ภาษากาลิเชียน",
    "zh-hans": "加利西亚文",
    originalName: "galego",
  },
  ca: {
    "zh-TW": "加泰羅尼亞文",
    en: "Catalan",
    ja: "カタロニア語",
    th: "ภาษาคาตาลัน",
    "zh-hans": "加泰罗尼亚文",
    originalName: "català",
  },
  kn: {
    "zh-TW": "卡納達文",
    en: "Kannada",
    ja: "カンナダ語",
    th: "ภาษากันนาดา",
    "zh-hans": "卡纳达文",
    originalName: "ಕನ್ನಡ",
  },
  ne: {
    "zh-TW": "尼泊爾文",
    en: "Nepali",
    ja: "ネパール語",
    th: "ภาษาเนปาล",
    "zh-hans": "尼泊尔文",
    originalName: "नेपाली",
  },
  af: {
    "zh-TW": "布爾文",
    en: "Afrikaans",
    ja: "アフリカーンス語",
    th: "ภาษาแอฟริกานส์",
    "zh-hans": "南非语",
    originalName: "Afrikaans",
  },
  fy: {
    "zh-TW": "弗利然文",
    en: "Frisian",
    ja: "フリジア語",
    th: "ภาษาฟริเชียน",
    "zh-hans": "弗里西亚文",
    originalName: "Frysk",
  },
  be: {
    "zh-TW": "白俄羅斯文",
    en: "Belarusian",
    ja: "ベラルーシ語",
    th: "ภาษาเบลารัส",
    "zh-hans": "白俄罗斯文",
    originalName: "Беларуская",
  },
  lt: {
    "zh-TW": "立陶宛文",
    en: "Lithuanian",
    ja: "リトアニア語",
    th: "ภาษาลิทัวเนีย",
    "zh-hans": "立陶宛文",
    originalName: "lietuvių",
  },
  ig: {
    "zh-TW": "伊博文",
    en: "Igbo",
    ja: "イボ語",
    th: "ภาษาอิกโบ",
    "zh-hans": "伊博文",
    originalName: "Igbo",
  },
  is: {
    "zh-TW": "冰島文",
    en: "Icelandic",
    ja: "アイスランド語",
    th: "ภาษาไอซ์แลนด์",
    "zh-hans": "冰岛文",
    originalName: "íslenska",
  },
  hu: {
    "zh-TW": "匈牙利文",
    en: "Hungarian",
    ja: "ハンガリー語",
    th: "ภาษาฮังการี",
    "zh-hans": "匈牙利文",
    originalName: "magyar",
  },
  id: {
    "zh-TW": "印尼文",
    en: "Indonesian",
    ja: "インドネシア語",
    th: "ภาษาอินโดนีเชีย",
    "zh-hans": "印度尼西亚文",
    originalName: "Indonesia",
  },
  su: {
    "zh-TW": "印尼巽他文",
    en: "Sundanese",
    ja: "スンダ語",
    th: "ภาษาซันดา",
    "zh-hans": "印尼巽他文",
    originalName: "Basa Sunda",
  },
  hi: {
    "zh-TW": "印度文",
    en: "Hindi",
    ja: "ヒンディー語",
    th: "ภาษาฮินดี",
    "zh-hans": "印地文",
    originalName: "हिन्दी",
  },
  gu: {
    "zh-TW": "印度古哈拉地文",
    en: "Gujarati",
    ja: "グジャラート語",
    th: "ภาษากูจาราติ",
    "zh-hans": "古吉拉特文",
    originalName: "ગુજરાતી",
  },
  ky: {
    "zh-TW": "吉爾吉斯文",
    en: "Kyrgyz",
    ja: "キルギス語",
    th: "ภาษาคีร์กิซ",
    "zh-hans": "吉尔吉斯文",
    originalName: "кыргызча",
  },
  es: {
    "zh-TW": "西班牙文",
    en: "Spanish",
    ja: "スペイン語",
    th: "ภาษาสเปน",
    "zh-hans": "西班牙文",
    originalName: "español",
  },
  hr: {
    "zh-TW": "克羅埃西亞文",
    en: "Croatian",
    ja: "クロアチア語",
    th: "ภาษาโครเอเชีย",
    "zh-hans": "克罗地亚文",
    originalName: "hrvatski",
  },
  iw: {
    "zh-TW": "希伯來文",
    en: "Hebrew",
    ja: "ヘブライ語",
    th: "ภาษาฮีบรู",
    "zh-hans": "希伯来文",
    originalName: "עברית",
  },
  el: {
    "zh-TW": "希臘文",
    en: "Greek",
    ja: "ギリシャ語",
    th: "ภาษากรีก",
    "zh-hans": "希腊文",
    originalName: "Ελληνικά",
  },
  hy: {
    "zh-TW": "亞美尼亞文",
    en: "Armenian",
    ja: "アルメニア語",
    th: "ภาษาอาร์มีเนีย",
    "zh-hans": "亚美尼亚文",
    originalName: "հայերեն",
  },
  az: {
    "zh-TW": "亞塞拜然文",
    en: "Azerbaijani",
    ja: "アゼルバイジャン語",
    th: "ภาษาอาเซอร์ไบจาน",
    "zh-hans": "阿塞拜疆文",
    originalName: "Azərbaycan dili",
  },
  ny: {
    "zh-TW": "奇切瓦文",
    en: "Chichewa",
    ja: "チチェワ語",
    th: "ภาษาชิเชวา",
    "zh-hans": "奇切瓦文",
    originalName: "Chichewa",
  },
  bn: {
    "zh-TW": "孟加拉文",
    en: "Bengali",
    ja: "ベンガル語",
    th: "ภาษาเบนกาลี",
    "zh-hans": "孟加拉文",
    originalName: "বাংলা",
  },
  ps: {
    "zh-TW": "帕施圖文",
    en: "Pashto",
    ja: "パシュトー語",
    th: "ภาษาปัชโต",
    "zh-hans": "普什图文",
    originalName: "پښتو",
  },
  la: {
    "zh-TW": "拉丁文",
    en: "Latin",
    ja: "ラテン語",
    th: "ภาษาละติน",
    "zh-hans": "拉丁文",
    originalName: "lingua latīna",
  },
  lv: {
    "zh-TW": "拉脫維亞文",
    en: "Latvian",
    ja: "ラトビア語",
    th: "ภาษาลัตเวีย",
    "zh-hans": "拉脱维亚文",
    originalName: "latviešu",
  },
  fr: {
    "zh-TW": "法文",
    en: "French",
    ja: "フランス語",
    th: "ภาษาฝรั่งเศส",
    "zh-hans": "法文",
    originalName: "Français",
  },
  bs: {
    "zh-TW": "波士尼亞文",
    en: "Bosnian",
    ja: "ボスニア語",
    th: "ภาษาบอสเนีย",
    "zh-hans": "波斯尼亚文",
    originalName: "bosanski",
  },
  fa: {
    "zh-TW": "波斯文",
    en: "Persian",
    ja: "ペルシア語",
    th: "ภาษาเปอร์เชีย",
    "zh-hans": "波斯文",
    originalName: "فارسی",
  },
  pl: {
    "zh-TW": "波蘭文",
    en: "Polish",
    ja: "ポーランド語",
    th: "ภาษาโปแลนด์",
    "zh-hans": "波兰文",
    originalName: "polski",
  },
  fi: {
    "zh-TW": "芬蘭文",
    en: "Finnish",
    ja: "フィンランド語",
    th: "ภาษาฟินแลนด์",
    "zh-hans": "芬兰文",
    originalName: "suomi",
  },
  am: {
    "zh-TW": "阿姆哈拉文",
    en: "Amharic",
    ja: "アムハラ語",
    th: "ภาษาอัมฮาริก",
    "zh-hans": "阿姆哈拉文",
    originalName: "አማርኛ",
  },
  ar: {
    "zh-TW": "阿拉伯文",
    en: "Arabic",
    ja: "アラビア語",
    th: "ภาษาอาหรับ",
    "zh-hans": "阿拉伯文",
    originalName: "العربية",
  },
  sq: {
    "zh-TW": "阿爾巴尼亞文",
    en: "Albanian",
    ja: "アルバニア語",
    th: "ภาษาแอลเบเนีย",
    "zh-hans": "阿尔巴尼亚文",
    originalName: "Shqip",
  },
  ru: {
    "zh-TW": "俄文",
    en: "Russian",
    ja: "ロシア語",
    th: "ภาษารัสเซีย",
    "zh-hans": "俄文",
    originalName: "русский",
  },
  bg: {
    "zh-TW": "保加利亞文",
    en: "Bulgarian",
    ja: "ブルガリア語",
    th: "ภาษาบัลแกเรีย",
    "zh-hans": "保加利亚文",
    originalName: "български",
  },
  sd: {
    "zh-TW": "信德文",
    en: "Sindhi",
    ja: "シンド語",
    th: "ภาษาซินดี",
    "zh-hans": "信德文",
    originalName: "سنڌي",
  },
  xh: {
    "zh-TW": "南非柯薩文",
    en: "Xhosa",
    ja: "コサ語",
    th: "ภาษาโคซ่า",
    "zh-hans": "科萨语",
    originalName: "IsiXhosa",
  },
  zu: {
    "zh-TW": "南非祖魯文",
    en: "Zulu",
    ja: "ズールー語",
    th: "ภาษาซูลู",
    "zh-hans": "祖鲁语",
    originalName: "isiZulu",
  },
  kk: {
    "zh-TW": "哈薩克文",
    en: "Kazakh",
    ja: "カザフ語",
    th: "ภาษาคาซัค",
    "zh-hans": "哈萨克文",
    originalName: "қазақ",
  },
  cy: {
    "zh-TW": "威爾斯文",
    en: "Welsh",
    ja: "ウェールズ語",
    th: "ภาษาเวลส์",
    "zh-hans": "威尔士文",
    originalName: "Cymraeg",
  },
  co: {
    "zh-TW": "科西嘉文",
    en: "Corsican",
    ja: "コルシカ語",
    th: "ภาษาคอรฌิกา",
    "zh-hans": "科西嘉文",
    originalName: "Corse",
  },
  hmn: {
    "zh-TW": "苗文",
    en: "Hmong",
    ja: "モン語",
    th: "ภาษามง",
    "zh-hans": "苗文",
    originalName: "Hmong",
  },
  en: {
    "zh-TW": "英文",
    en: "English",
    ja: "英語",
    th: "ภาษาอังกฤษ",
    "zh-hans": "英文",
    originalName: "English",
  },
  haw: {
    "zh-TW": "夏威夷文",
    en: "Hawaiian",
    ja: "ハワイ語",
    th: "ภาษาฮาวาย",
    "zh-hans": "夏威夷文",
    originalName: "Ōlelo Hawaiʻi",
  },
  ku: {
    "zh-TW": "庫德文",
    en: "Kurdish (Kurmanji)",
    ja: "クルド語",
    th: "ภาษาเคิร์ด",
    "zh-hans": "库尔德文",
    originalName: "Kurdî",
  },
  no: {
    "zh-TW": "挪威文",
    en: "Norwegian",
    ja: "ノルウェー語",
    th: "ภาษานอร์เวย์",
    "zh-hans": "挪威文",
    originalName: "norsk",
  },
  pa: {
    "zh-TW": "旁遮普文",
    en: "Punjabi",
    ja: "パンジャーブ語",
    th: "ภาษาปัญจาบ",
    "zh-hans": "旁遮普文",
    originalName: "ਪੰਜਾਬੀ",
  },
  th: {
    "zh-TW": "泰文",
    en: "Thai",
    ja: "タイ語",
    th: "ภาษาไทย",
    "zh-hans": "泰文",
    originalName: "ภาษาไทย",
  },
  ta: {
    "zh-TW": "泰米爾文",
    en: "Tamil",
    ja: "タミル語",
    th: "ภาษาทมิฬ",
    "zh-hans": "泰米尔文",
    originalName: "தமிழ்",
  },
  te: {
    "zh-TW": "泰盧固文",
    en: "Telugu",
    ja: "テルグ語",
    th: "ภาษาเตลูกู",
    "zh-hans": "泰卢固文",
    originalName: "తెలుగు",
  },
  ht: {
    "zh-TW": "海地克里奧文",
    en: "Haitian Creole",
    ja: "ハイチクリオール語",
    th: "ภาษาเครีโอลไฮติ",
    "zh-hans": "海地克里奥尔文",
    originalName: "Kreyòl Ayisyen",
  },
  uk: {
    "zh-TW": "烏克蘭文",
    en: "Ukrainian",
    ja: "ウクライナ語",
    th: "ภาษายูเครน",
    "zh-hans": "乌克兰文",
    originalName: "українська",
  },
  uz: {
    "zh-TW": "烏茲別克文",
    en: "Uzbek",
    ja: "ウズベク語",
    th: "ภาษาอุซเบก",
    "zh-hans": "乌兹别克文",
    originalName: "O'zbek",
  },
  ur: {
    "zh-TW": "烏爾都文",
    en: "Urdu",
    ja: "ウルドゥー語",
    th: "ภาษาอูรดู",
    "zh-hans": "乌尔都文",
    originalName: "اردو",
  },
  so: {
    "zh-TW": "索馬里文",
    en: "Somali",
    ja: "ソマリ語",
    th: "ภาษาโซมาลี",
    "zh-hans": "索马里文",
    originalName: "Soomaali",
  },
  mt: {
    "zh-TW": "馬耳他文",
    en: "Maltese",
    ja: "マルタ語",
    th: "ภาษามอลตา",
    "zh-hans": "马耳他文",
    originalName: "Malti",
  },
  ms: {
    "zh-TW": "馬來文",
    en: "Malay",
    ja: "マレー語",
    th: "ภาษามาเลย์",
    "zh-hans": "马来文",
    originalName: "Melayu",
  },
  mk: {
    "zh-TW": "馬其頓文",
    en: "Macedonian",
    ja: "マケドニア語",
    th: "ภาษามาซิโดเนีย",
    "zh-hans": "马其顿文",
    originalName: "македонски",
  },
  mg: {
    "zh-TW": "馬拉加斯文",
    en: "Malagasy",
    ja: "マラガシ語",
    th: "ภาษามาลากาซี",
    "zh-hans": "马拉加斯文",
    originalName: "Malagasy",
  },
  mr: {
    "zh-TW": "馬拉地文",
    en: "Marathi",
    ja: "マラーティー語",
    th: "ภาษามราฐี",
    "zh-hans": "马拉地文",
    originalName: "मराठी",
  },
  ml: {
    "zh-TW": "馬拉雅拉姆文",
    en: "Malayalam",
    ja: "マラヤーラム語",
    th: "ภาษามาลายาลัม",
    "zh-hans": "马拉雅拉姆文",
    originalName: "മലയാളം",
  },
  km: {
    "zh-TW": "高棉文",
    en: "Khmer",
    ja: "クメール語",
    th: "ภาษาเขมร",
    "zh-hans": "高棉文",
    originalName: "ខ្មែរ",
  },
  ceb: {
    "zh-TW": "宿霧文",
    en: "Cebuano",
    ja: "セブアノ語",
    th: "ภาษาเซบูอาโน",
    "zh-hans": "宿务文",
    originalName: "Cebuano",
  },
  cs: {
    "zh-TW": "捷克文",
    en: "Czech",
    ja: "チェコ語",
    th: "ภาษาเช็ค",
    "zh-hans": "捷克文",
    originalName: "čeština",
  },
  sn: {
    "zh-TW": "紹納文",
    en: "Shona",
    ja: "ショナ語",
    th: "ภาษาโชนา",
    "zh-hans": "绍纳文",
    originalName: "ChiShona",
  },
  nl: {
    "zh-TW": "荷蘭文",
    en: "Dutch",
    ja: "オランダ語",
    th: "ภาษาดัตช์",
    "zh-hans": "荷兰文",
    originalName: "Nederlands",
  },
  ka: {
    "zh-TW": "喬治亞文",
    en: "Georgian",
    ja: "グルジア語",
    th: "ภาษาจอร์เจีย",
    "zh-hans": "格鲁吉亚文",
    originalName: "ქართული",
  },
  sw: {
    "zh-TW": "斯瓦希里文",
    en: "Swahili",
    ja: "スワヒリ語",
    th: "ภาษาสวาฮิลี",
    "zh-hans": "斯瓦希里文",
    originalName: "Kiswahili",
  },
  sk: {
    "zh-TW": "斯洛伐克文",
    en: "Slovak",
    ja: "スロバキア語",
    th: "ภาษาสโลวัก",
    "zh-hans": "斯洛伐克文",
    originalName: "slovenčina",
  },
  sl: {
    "zh-TW": "斯洛維尼亞文",
    en: "Slovenian",
    ja: "スロベニア語",
    th: "ภาษาสโลวีเนีย",
    "zh-hans": "斯洛文尼亚文",
    originalName: "slovenščina",
  },
  tl: {
    "zh-TW": "菲律賓文",
    en: "Filipino",
    ja: "フィリピン語",
    th: "ภาษาฟิลิปปินส์",
    "zh-hans": "菲律宾文",
    originalName: "Filipino",
  },
  vi: {
    "zh-TW": "越南文",
    en: "Vietnamese",
    ja: "ベトナム語",
    th: "ภาษาเวียดนาม",
    "zh-hans": "越南文",
    originalName: "Tiếng Việt",
  },
  tg: {
    "zh-TW": "塔吉克文",
    en: "Tajik",
    ja: "タジク語",
    th: "ภาษาทาจิก",
    "zh-hans": "塔吉克文",
    originalName: "Тоҷикӣ",
  },
  sr: {
    "zh-TW": "塞爾維亞文",
    en: "Serbian",
    ja: "セルビア語",
    th: "ภาษาเซอร์เบีย",
    "zh-hans": "塞尔维亚文",
    originalName: "српски",
  },
  yi: {
    "zh-TW": "意第緒文",
    en: "Yiddish",
    ja: "イーディッシュ語",
    th: "ภาษายิดดิช",
    "zh-hans": "意第绪文",
    originalName: "יידיש",
  },
  et: {
    "zh-TW": "愛沙尼亞文",
    en: "Estonian",
    ja: "エストニア語",
    th: "ภาษาเอสโตเนีย",
    "zh-hans": "爱沙尼亚文",
    originalName: "eesti",
  },
  ga: {
    "zh-TW": "愛爾蘭文",
    en: "Irish",
    ja: "アイルランド語",
    th: "ภาษาไอริช",
    "zh-hans": "爱尔兰文",
    originalName: "Gaeilge",
  },
  sv: {
    "zh-TW": "瑞典文",
    en: "Swedish",
    ja: "スウェーデン語",
    th: "ภาษาสวีเดน",
    "zh-hans": "瑞典文",
    originalName: "svenska",
  },
  st: {
    "zh-TW": "瑟索托文",
    en: "Sesotho",
    ja: "セソト語",
    th: "ภาษาเซโซโต",
    "zh-hans": "塞索托文",
    originalName: "Sesotho",
  },
  it: {
    "zh-TW": "義大利文",
    en: "Italian",
    ja: "イタリア語",
    th: "ภาษาอิตาลี",
    "zh-hans": "意大利文",
    originalName: "Italiano",
  },
  pt: {
    "zh-TW": "葡萄牙文",
    en: "Portuguese",
    ja: "ポルトガル語",
    th: "ภาษาโปรตุเกส",
    "zh-hans": "葡萄牙文",
    originalName: "Português",
  },
  mn: {
    "zh-TW": "蒙古文",
    en: "Mongolian",
    ja: "モンゴル語",
    th: "ภาษามองโกล",
    "zh-hans": "蒙古文",
    originalName: "Монгол",
  },
  ha: {
    "zh-TW": "豪沙文",
    en: "Hausa",
    ja: "ハウサ語",
    th: "ภาษาเฮาซา",
    "zh-hans": "豪沙文",
    originalName: "Hausa",
  },
  lo: {
    "zh-TW": "寮文",
    en: "Lao",
    ja: "ラオ語",
    th: "ภาษาลาว",
    "zh-hans": "老文",
    originalName: "ລາວ",
  },
  de: {
    "zh-TW": "德文",
    en: "German",
    ja: "ドイツ語",
    th: "ภาษาเยอรมัน",
    "zh-hans": "德文",
    originalName: "Deutsch",
  },
  my: {
    "zh-TW": "緬甸文",
    en: "Myanmar (Burmese)",
    ja: "ミャンマー語",
    th: "ภาษาพม่า",
    "zh-hans": "缅甸文",
    originalName: "မြန်မာ (မြန်မာ)",
  },
  lb: {
    "zh-TW": "盧森堡文",
    en: "Luxembourgish",
    ja: "ルクセンブルク語",
    th: "ภาษาลักเซมเบิร์ก",
    "zh-hans": "卢森堡文",
    originalName: "Lëtzebuergesch",
  },
  si: {
    "zh-TW": "錫蘭文",
    en: "Sinhala",
    ja: "シンハラ語",
    th: "ภาษาสิงหล",
    "zh-hans": "僧伽罗文",
    originalName: "සිංහල",
  },
  yo: {
    "zh-TW": "優魯巴文",
    en: "Yoruba",
    ja: "ヨルバ語",
    th: "ภาษาโยรูบา",
    "zh-hans": "约鲁巴文",
    originalName: "Èdè Yorùbá",
  },
  ko: {
    "zh-TW": "韓文",
    en: "Korean",
    ja: "韓国語",
    th: "ภาษาเกาหลี",
    "zh-hans": "韩文",
    originalName: "한국어",
  },
  sm: {
    "zh-TW": "薩摩亞文",
    en: "Samoan",
    ja: "サモア語",
    th: "ภาษาซามัว",
    "zh-hans": "萨摩亚文",
    originalName: "Sāmoa",
  },
  ro: {
    "zh-TW": "羅馬尼亞文",
    en: "Romanian",
    ja: "ルーマニア語",
    th: "ภาษาโรมัน",
    "zh-hans": "罗马尼亚文",
    originalName: "Română",
  },
  gd: {
    "zh-TW": "蘇格蘭的蓋爾文",
    en: "Scots Gaelic",
    ja: "スコットランドゲール語",
    th: "ภาษาเกลส์สกอต",
    "zh-hans": "苏格兰盖尔语",
    originalName: "Gàidhlig",
  },
};

// Below is for old use case, not standard language code

const languageCodesDataForOldUseCase = {
  tw: {
    "zh-TW": "中文 (繁體)",
    en: "Chinese (Traditional)",
    originalName: "中文 (繁體)",
  },
  cz: { "zh-TW": "捷克文", en: "Czech", originalName: "čeština" },
};

const defaultLanguageCodeData = {
  default: {
    "zh-TW": "預設",
    en: "Default",
    originalName: "Default",
  },
};

export {
  languageCodesDataForOldUseCase,
  languageCodesData,
  defaultLanguageCodeData,
  languageType,
};
